import store from "@/store";
import domainApi from "./domain.api";
import Logger from "@/helpers/logger";
import { safeParseJSON } from "@/helpers";

class DomainService {
  async getDnsConfig(params) {
    try {
      const data = await domainApi.getDnsConfig(params);
      let dnsConfig = data;
      let tmpDnsConfig = localStorage.getItem("dnsConfig");
      if (tmpDnsConfig) {
        tmpDnsConfig = safeParseJSON(tmpDnsConfig);
        dnsConfig = {
          ...dnsConfig,
          ...tmpDnsConfig,
        };
      }
      store.dispatch("domain/domainConnectData", dnsConfig);
      return dnsConfig;
    } catch (e) {
      Logger.error("`getDnsConfig` service", e);
      return Promise.reject(e);
    }
  }

  async getDnsRecords() {
    try {
      const data = await domainApi.getDnsRecords();
      return data;
    } catch (e) {
      Logger.error("`getDnsRecords` service", e);
      return Promise.reject(e);
    }
  }

  async verifyDkim(params) {
    try {
      const data = await domainApi.verifyDkim(params);
      return data;
    } catch (e) {
      Logger.error("`verifyDkim` service", e);
      return Promise.reject(e);
    }
  }

  async generateDkim() {
    try {
      const data = await domainApi.generateDkim();
      return data;
    } catch (e) {
      Logger.error("`generateDkim` service", e);
      return Promise.reject(e);
    }
  }

  async deleteDnsRecord(payload) {
    try {
      const data = await domainApi.deleteDnsRecord(payload);
      return data;
    } catch (e) {
      Logger.error("`deleteDnsRecord` service", e);
      return Promise.reject(e);
    }
  }

  async upsertDnsRecord(payload) {
    try {
      const data = await domainApi.upsertDnsRecord(payload);
      return data;
    } catch (e) {
      Logger.error("`upsertDnsRecord` service", e);
      return Promise.reject(e);
    }
  }

  async dkimEnable(payload) {
    try {
      const data = await domainApi.dkimEnable(payload);
      return data;
    } catch (e) {
      Logger.error("`dkimEnable` service", e);
      return Promise.reject(e);
    }
  }

  async dkimDelete(payload) {
    try {
      const data = await domainApi.dkimDelete(payload);
      return data;
    } catch (e) {
      Logger.error("`dkimDelete` service", e);
      return Promise.reject(e);
    }
  }

  async getDnsRecordType(payload) {
    try {
      const data = await domainApi.getDnsRecordType(payload);
      return data;
    } catch (e) {
      Logger.error("`getDnsRecordType` service", e);
      return Promise.reject(e);
    }
  }
}

const domainService = new DomainService();

export default domainService;
